import '../../types/index.js';
import { A as ActionStatus } from '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';

const initialState = {
    addresses: [],
    countries: [],
    cart: {
        check_mattress_recovery: false,
        email: null,
        items: [],
        prices: null,
        shipping_addresses: [],
        billing_address: null,
        applied_coupons: [],
        available_payment_methods: [],
        selected_payment_method: null,
    },
    almaPaymentMethod: null,
    expressPaymentMethod: null,
    processPayment: {
        generalStatus: ActionStatus.Idle,
        validationStatus: {
            email: ActionStatus.Idle,
            shipping: ActionStatus.Idle,
            billing: ActionStatus.Idle,
            paymentMethod: ActionStatus.Idle,
        },
        requestStatus: {
            email: ActionStatus.Idle,
            shipping: ActionStatus.Idle,
            paymentMethod: ActionStatus.Idle,
        },
        payload: {
            email: null,
            shipping: null,
            billing: null,
            paymentMethod: null,
        },
    },
    updateCustomerData: {
        initCount: 0,
        payload: {
            email: null,
            firstName: null,
            lastName: null,
            phoneNumber: null,
            countryCode: null,
            region: null,
            city: null,
            address1: null,
            address2: null,
            postCode: null,
        },
    },
    loadingShippingFeeAndPaymentMethod: false,
    loadingPaymentButton: false,
    extraErrors: null,
};

export { initialState };
//# sourceMappingURL=initialState.js.map
